// SortableAccordionItem.jsx
import { AccordionItem } from "@chakra-ui/react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { forwardRef } from "react";

const SortableAccordionItem = forwardRef(({ id, children, ...props }, ref) => {
  const { setNodeRef, transform, transition, attributes, listeners } =
    useSortable({ id });

  return (
    <AccordionItem
      ref={(node) => {
        setNodeRef(node);
        if (ref) ref.current = node;
      }}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...props}
    >
      {children({ attributes, listeners })}
    </AccordionItem>
  );
});

export default SortableAccordionItem;
